var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cont-wrap" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.imgLoading,
            expression: "imgLoading"
          }
        ],
        ref: "bigBox",
        staticClass: "contract-view",
        on: {
          drop: function($event) {
            return _vm.dropData($event)
          },
          dragover: function($event) {
            $event.preventDefault()
          }
        }
      },
      [
        _c(
          "div",
          { staticClass: "slider-top" },
          [
            _c("el-slider", {
              staticClass: "slider-bar",
              attrs: {
                value: _vm.scaleValue,
                min: 50,
                max: 200,
                "show-input": ""
              },
              on: {
                input: function(val) {
                  this$1.$emit("update:scaleValue", val)
                }
              }
            }),
            _c("span", [_vm._v(_vm._s(_vm.page) + "/" + _vm._s(_vm.items))])
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "big-box",
            style: "transform:scale(" + _vm.scaleValue / 100 + ");"
          },
          [
            _c(
              "div",
              {
                ref: "contBox",
                staticClass: "cont-box",
                attrs: { id: "contBox" }
              },
              [
                _c("img", {
                  key: _vm.page,
                  staticClass: "imgInfo",
                  attrs: {
                    onerror: "this.src='/images/logo/jzq-logo.png'",
                    src: _vm.contractInfo.url,
                    alt: "合同信息"
                  },
                  on: {
                    load: _vm.handleImgLoad,
                    mousedown: function($event) {
                      if ($event.target !== $event.currentTarget) {
                        return null
                      }
                      return _vm.pageMousedown($event)
                    },
                    mouseleave: function($event) {
                      return _vm.pageLeave($event)
                    },
                    mouseup: function(e) {
                      this$1.handleSetChapte(e)
                    }
                  }
                }),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: false,
                        expression: "false"
                      }
                    ],
                    class: {
                      "widgets-wrap": true,
                      maxTop: true,
                      move: true,
                      fixed: true
                    },
                    style: _vm.addBtnStyle,
                    attrs: { type: "danger", size: "small" },
                    on: { click: _vm.variableAdd }
                  },
                  [_vm._v("添加变量")]
                ),
                _vm._l(_vm.chapterList, function(item, index) {
                  return [
                    _vm.imgLoadSus &&
                    !_vm.imgLoading &&
                    item.page === _vm.page - 1
                      ? [
                          item.varType >= _vm.flagType.flag.SIGNNATURE
                            ? [
                                _c("signature", {
                                  key: index + "signature",
                                  attrs: {
                                    relativeNodeId: "contBox",
                                    scaleValue: _vm.scaleValue,
                                    loopkey: index,
                                    "item-info": item,
                                    items: _vm.items
                                  },
                                  on: {
                                    quoteCopy: _vm.quoteCopy,
                                    BatchSettinsClose: _vm.BatchSettinsClose,
                                    changeItemInfo: _vm.changeWidgets,
                                    delItemInfo: _vm.delWidgets
                                  }
                                })
                              ]
                            : [
                                _c("widgets", {
                                  key: index + "widgets",
                                  ref: "widgets",
                                  refInFor: true,
                                  attrs: {
                                    relativeNodeId: "contBox",
                                    scaleValue: _vm.scaleValue,
                                    loopkey: index,
                                    "item-info": item
                                  },
                                  on: {
                                    click: _vm.selectJCCom,
                                    changeItemInfo: _vm.changeWidgets,
                                    delItemInfo: _vm.delWidgets,
                                    quoteCopy: _vm.quoteCopy,
                                    synchronous: _vm.synchronous
                                  }
                                })
                              ]
                        ]
                      : _vm._e()
                  ]
                })
              ],
              2
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38b5c2aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38b5c2aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/advancedVersion/contractView.vue
// module id = ZnlI
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25